<svg
  width="184"
  height="120"
  viewBox="0 0 184 120"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_1227_39362)">
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H178C181.314 0 184 2.68629 184 6V114C184 117.314 181.314 120 178 120H6C2.68629 120 0 117.314 0 114V6Z"
      fill="#EBEAED"
    />
    <g clip-path="url(#clip1_1227_39362)">
      <mask id="path-5-inside-1_1227_39362" fill="white">
        <path d="M12 12H172V21.6H12V12Z" />
      </mask>
      <path d="M12 12H172V21.6H12V12Z" fill="white" />
      <ellipse cx="16.7999" cy="16.8" rx="1.59993" ry="1.6" fill="#9027FF" />
      <ellipse cx="21.5997" cy="16.8" rx="1.59993" ry="1.6" fill="#FA52F1" />
      <ellipse cx="26.3995" cy="16.8" rx="1.59993" ry="1.6" fill="#FA9F34" />
      <rect
        x="152.8"
        y="14.3999"
        width="16"
        height="4.8"
        rx="0.8"
        fill="#EBEAED"
      />
      <path
        d="M172 21.2H12V22H172V21.2Z"
        fill="#D6D4D9"
        mask="url(#path-5-inside-1_1227_39362)"
      />
      <rect
        width="160"
        height="111.25"
        transform="translate(12 21.6001)"
        fill="white"
      />
      <rect
        x="15.2"
        y="28.6001"
        width="18"
        height="3.2"
        rx="0.8"
        fill="#EBEAED"
      />
      <rect x="15.2" y="35" width="18" height="3.2" rx="0.8" fill="#EBEAED" />
      <rect
        x="15.2"
        y="41.4001"
        width="18"
        height="3.2"
        rx="0.8"
        fill="#EBEAED"
      />
      <rect x="15.2" y="47.8" width="18" height="3.2" rx="0.8" fill="#BB7AFF" />
      <rect
        x="15.2"
        y="54.2002"
        width="18"
        height="3.2"
        rx="0.8"
        fill="#EBEAED"
      />
      <rect
        x="15.2"
        y="60.6001"
        width="18"
        height="3.2"
        rx="0.8"
        fill="#EBEAED"
      />
      <rect x="15.2" y="67" width="18" height="3.2" rx="0.8" fill="#EBEAED" />
      <path
        d="M42.4 21.6001V132.85H43.2V21.6001H42.4Z"
        fill="#D6D4D9"
        mask="url(#path-11-inside-2_1227_39362)"
      />
      <rect x="49.2" y="28" width="23" height="6" rx="0.8" fill="#EBEAED" />
      <rect
        x="49.2"
        y="37.2"
        width="26.7"
        height="16"
        rx="1.6"
        fill="#BB7AFF"
      />
      <rect
        x="79.0999"
        y="37.2"
        width="26.7"
        height="16"
        rx="1.6"
        fill="#EBEAED"
      />
      <rect x="109" y="37.2" width="26.7" height="16" rx="1.6" fill="#EBEAED" />
      <rect
        x="138.9"
        y="37.2"
        width="26.7"
        height="16"
        rx="1.6"
        fill="#EBEAED"
      />
      <rect
        x="49.2"
        y="62.8"
        width="25.6"
        height="4.8"
        rx="0.8"
        fill="#EBEAED"
      />
      <g clip-path="url(#clip2_1227_39362)">
        <line
          x1="49.2"
          y1="75.6"
          x2="165.6"
          y2="75.6001"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="81.4001"
          x2="165.6"
          y2="81.4001"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="87.1999"
          x2="165.6"
          y2="87.1999"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="93"
          x2="165.6"
          y2="93"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="98.8"
          x2="165.6"
          y2="98.8"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="104.6"
          x2="165.6"
          y2="104.6"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="110.4"
          x2="165.6"
          y2="110.4"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <line
          x1="49.2"
          y1="116.2"
          x2="165.6"
          y2="116.2"
          stroke="#EBEAED"
          stroke-width="0.4"
        />
        <path
          d="M48.4964 113.491L44.0786 112.279V116.489H170.721V103.986L168.676 111.96L164.258 114.32L162.049 113.3L159.759 109.727H157.55L155.341 114.639L153.132 103.731L150.841 111.386L148.714 107.367L146.505 114.958L144.297 113.746L142.006 113.938L139.797 115.405L137.588 103.284L135.379 114.639L133.089 110.301L130.88 111.067L128.589 113.81L126.462 112.726L124.171 113.81L121.962 110.174L119.672 110.939L117.545 112.853L115.254 105.581L113.127 107.175L110.918 113.427L108.627 108.132L106.336 111.258L104.046 113.045L102 112.407L99.628 114.703L97.5009 109.089L95.292 106.92L92.9195 112.215L90.7106 113.427L88.6654 115.277L86.3747 110.493L84.0022 111.258L81.9569 110.493L79.6662 105.07L77.4573 109.408L75.2484 110.684L72.9577 75.342L70.7489 115.277L68.6218 114.193L66.4129 112.024L64.5313 113.172L61.9133 114.32L59.7044 107.239L57.5774 112.279L55.2049 113.874H53.0778L50.7871 111.067L48.4964 113.491Z"
          fill="url(#paint0_linear_1227_39362)"
        />
        <path
          d="M44.0786 112.279L48.4964 113.491L50.7871 111.067L53.0778 113.874H55.2049L57.5774 112.279L59.7044 107.239L61.9133 114.32L64.5313 113.172L66.4129 112.024L68.6218 114.193L70.7489 115.277L72.9577 75.342L75.2484 110.684L77.4573 109.408L79.6662 105.07L81.9569 110.493L84.0022 111.258L86.3747 110.493L88.6654 115.277L90.7106 113.427L92.9195 112.215L95.292 106.92L97.5009 109.089L99.628 114.703L102.001 112.407L104.046 113.045L106.336 111.258L108.627 108.132L110.918 113.427L113.127 107.175L115.254 105.581L117.545 112.853L119.672 110.939L121.962 110.174L124.171 113.81L126.462 112.726L128.589 113.81L130.88 111.067L133.089 110.301L135.379 114.639L137.588 103.284L139.797 115.405L142.006 113.938L144.297 113.746L146.505 114.958L148.714 107.367L150.841 111.386L153.132 103.731L155.341 114.639L157.55 109.727H159.759L162.049 113.3L164.258 114.32L168.676 111.96L170.721 103.986"
          stroke="#9027FF"
          stroke-width="0.4"
        />
      </g>
    </g>
    <rect
      x="12.2"
      y="12.2"
      width="159.6"
      height="120.45"
      rx="3"
      stroke="#D6D4D9"
      stroke-width="0.4"
    />
  </g>
  <path
    d="M0.5 6C0.5 2.96244 2.96243 0.5 6 0.5H178C181.038 0.5 183.5 2.96243 183.5 6V114C183.5 117.038 181.038 119.5 178 119.5H6C2.96243 119.5 0.5 117.038 0.5 114V6Z"
    stroke="#D6D4D9"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1227_39362"
      x1="107.4"
      y1="75.342"
      x2="107.4"
      y2="116.489"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#A550FF" />
      <stop offset="1" stop-color="#A550FF" stop-opacity="0.05" />
    </linearGradient>
    <clipPath id="clip0_1227_39362">
      <path
        d="M0 6C0 2.68629 2.68629 0 6 0H178C181.314 0 184 2.68629 184 6V114C184 117.314 181.314 120 178 120H6C2.68629 120 0 117.314 0 114V6Z"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip1_1227_39362">
      <rect x="12" y="12" width="160" height="120.85" rx="3.2" fill="white" />
    </clipPath>
    <clipPath id="clip2_1227_39362">
      <rect
        x="49.2"
        y="70.1807"
        width="116.4"
        height="46.3081"
        rx="3.22581"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>
